import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectRegister = (state) => state.settings || initialState;

const selectSettingsError = createSelector(selectRegister, (registerState) => registerState.settingsError);

export { selectSettingsError };
